// extracted by mini-css-extract-plugin
module.exports = {"header":"HomePage_header__2Kucj","banner":"HomePage_banner__2t0EH","title":"HomePage_title__21rYV","subtitle":"HomePage_subtitle__117KZ"};